import React, { useState, useEffect } from "react";
import { Box, Grid, TextField, MenuItem } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import dayjs from "dayjs";
import OrderTakingDays from "./OrderTakingDays";

const PickupDetails = ({ profileData, setProfileData }) => {
  const parseTime = (timeStr) => {
    return dayjs()
      .hour(parseInt(timeStr.substring(0, 2), 10))
      .minute(parseInt(timeStr.substring(2), 10));
  };

  const [orderStartTime, setOrderStartTime] = useState(
    parseTime(profileData?.ondcSellerInfo?.orderTakingTime ? profileData.ondcSellerInfo.orderTakingTime.split(",")[0] : 0)
  );
  const [orderEndTime, setOrderEndTime] = useState(
    parseTime(profileData?.ondcSellerInfo?.orderTakingTime ?profileData.ondcSellerInfo.orderTakingTime.split(",")[1] : 0)
  );

  useEffect(() => {
    setProfileData((prevData) => ({
      ...prevData,
      ondcSellerInfo: {
        ...prevData.ondcSellerInfo,
        orderTakingTime: `${orderStartTime.format(
          "HHmm"
        )},${orderEndTime.format("HHmm")}`,
      },
    }));
  }, [orderStartTime, orderEndTime]);

  const handlePackingTimeChange = (e) => {
    setProfileData({
      ...profileData,
      customData: {
        ...profileData.customData,
        packingTime: e.target.value,
      },
    });
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box my={3}>
        <Grid container spacing={2}>
        <Grid item xs={12}>
            <OrderTakingDays
              orderTakingDays={profileData?.ondcSellerInfo?.orderTakingDays}
              setOrderTakingDays={(days) =>
                setProfileData((prevData) => ({
                  ...prevData,
                  ondcSellerInfo: {
                    ...prevData.ondcSellerInfo,
                    orderTakingDays: days,
                  },
                }))
              }
            />
          </Grid>
          <Grid item xs={12} container spacing={2} >
            <Grid item xs={6}>
              <TimePicker
                label="Storefront Opening Time"
                value={orderStartTime}
                onChange={(newValue) => setOrderStartTime(newValue)}
                maxTime={dayjs(orderEndTime).subtract(1, "hour")}
                ampm={false}
              />
            </Grid>
            <Grid item xs={6}>
              <TimePicker
                label="Storefront Closing Time"
                value={orderEndTime}
                onChange={(newValue) => setOrderEndTime(newValue)}
                minTime={dayjs(orderStartTime).add(1, "hour")}
                ampm={false}
              />
            </Grid>
          </Grid>
          
          <Grid item xs={12}>
            <TextField
              select
              fullWidth
              label="Packaging Time"
              value={profileData?.customData?.packingTime || "1-Hr"}
              onChange={handlePackingTimeChange}
            >
              {[1, 2, 3, 4, 5, 6, 12].map((value) => (
                <MenuItem key={value} value={`${value}-Hr`}>
                  {`${value}-Hr`}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField
              disabled
              fullWidth
              label="Pickup Address"
              value={`${profileData?.ondcSellerInfo?.pickupAddress?.address?.building}, ${profileData?.ondcSellerInfo?.pickupAddress?.address?.street}, ${profileData?.ondcSellerInfo?.pickupAddress?.address?.locality}`}
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              disabled
              fullWidth
              label="City"
              value={profileData?.ondcSellerInfo?.pickupAddress?.address?.city}
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              disabled
              fullWidth
              label="State"
              value={profileData?.ondcSellerInfo?.pickupAddress?.address?.state}
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </LocalizationProvider>
  );
};

export default PickupDetails;
